export default "__VITE_ASSET__CpkffJZ0__"